export default [
  {
    path: '/admin/default-commisions',
    name: 'default-commision',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/default-commision')
  }
]
